import { Injectable } from '@angular/core';

/**
 * Holds the provided methods of packaging while it is relevant (e.g. during signing), so
 * PackageTypeService can use them instead of the ones from current user's account configuration.
 *
 * This needs to live in its own singleton rather than on PackageTypeService itself: the typeahead
 * component re-provides PackageTypeService via `useClass`, which creates a fresh instance per
 * `<app-type-ahead-input>` rather than reusing the root-provided one, so state set on a directly
 * injected PackageTypeService instance would not be visible to the instance actually doing the search.
 */
@Injectable({
  providedIn: 'root',
})
export class PackageTypeContextService {
  private active = false;
  private methodsOfPackaging: string[] = [];

  set(methodsOfPackaging?: string[]): void {
    this.active = true;
    this.methodsOfPackaging = methodsOfPackaging || [];
  }

  clear(): void {
    this.active = false;
    this.methodsOfPackaging = [];
  }

  isActive(): boolean {
    return this.active;
  }

  get(): string[] {
    return this.methodsOfPackaging;
  }
}
